module.exports = __webpack_public_path__ + "static/media/LakeCarolina-Logo-New-3.6bc00e8f.png";